import config from '~/config';
const defaultImgs = new Map([
  ['01', 'zhuanli'],
  ['02', 'tech'],
  ['03', 'service'],
  ['04', 'crowd'],
  ['05', 'expert'],
  ['06', 'shop'],
  ['07', 'information'],
  ['08', 'crowd'],
]);

const defaultHTImgs = new Map([
  ['01', '01'],
  ['02', '02'],
  ['03', '03'],
  ['04', '04'],
  ['05', '05'],
  ['06', '06'],
  ['07', '07'],
  ['08', '08'],
]);

export const absUrl = (url) => {
  if (!!url == false) {
    return '';
  }
  if (url && url.startsWith('http')) {
    return url;
  } else if (url.startsWith('data:image')) {
    return url;
  } else {
    return config.baseImgUrl + url;
  }
};

export const defaultGoodImage = (code) => {
  if (code) {
    return require(`~/assets/images/${defaultImgs.get(code)}.png`);
  } else {
    return require(`~/assets/images/crow-no.png`);
  }
};

export const defaultImg = (code) => {
  return 'this.src="' + defaultGoodImage(code) + '"';
};

export const defaultHighTechImage = (code) => {
  return require(`~/assets/images/hightech/${defaultHTImgs.get(code)}.png`);
};

export const defaultHTImg = (code) => {
  return 'this.src="' + defaultHighTechImage(code) + '"';
};

export const arrayToMap = (array, key, value) => {
  const map = new Map();
  map.set('-1', '全部');
  array.forEach((_) => {
    map.set(_[key], _[value]);
  });
  console.log(map);
  return map;
};
